import React, { useContext, useCallback } from 'react';
import { DrawerContext } from '~/providers/DrawerProvider';
import CustomItemPanel from '..';
import { CartItem } from '~/types/Cart';

const useOpenCustomItemPanel = () => {
  const { openDrawer } = useContext(DrawerContext);
  return useCallback(({ onSubmit }: { onSubmit: (item: CartItem) => void }) => {
    openDrawer(
      ({ closeDrawer }) => {
        const handleSubmit = (cartItem: CartItem) => {
          closeDrawer();
          onSubmit(cartItem);
        };
        return <CustomItemPanel onSubmit={handleSubmit} />;
      },
      {
        height: '80%',
        placement: 'bottom',
        closable: true,
      }
    );
  }, []);
};

export default useOpenCustomItemPanel;
